import type { RouteRecordRaw } from 'vue-router';
import { appRoutes } from './app';
import { authRoutes } from './auth';

export const routes: RouteRecordRaw[] = [...appRoutes, ...authRoutes];
